export default __webpack_public_path__ + "static/media/hour-empty.ccfaacde.svg";